// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMSubHeader-module__font-s-10___RlJ9_ {
  font-size: 10px !important;
}

.BGMSubHeader-module__font-s-12___bd5bI {
  font-size: 12px !important;
}

.BGMSubHeader-module__font-s-13___IXCuW {
  font-size: 13px !important;
}

.BGMSubHeader-module__font-s-14___G8B4e {
  font-size: 14px !important;
}

.BGMSubHeader-module__font-s-15___lJlSW {
  font-size: 15px !important;
}

.BGMSubHeader-module__font-s-16___KkSJI {
  font-size: 16px !important;
}

.BGMSubHeader-module__font-s-18___A0dIY {
  font-size: 18px !important;
}

.BGMSubHeader-module__font-s-20___rkeuX {
  font-size: 20px !important;
}

.BGMSubHeader-module__font-s-22___YA1O6 {
  font-size: 22px !important;
}

.BGMSubHeader-module__font-s-28___MHV_U {
  font-size: 28px !important;
}

.BGMSubHeader-module__font-w-400___WRTM4 {
  font-weight: 400 !important;
}

.BGMSubHeader-module__font-w-500___apj_r {
  font-weight: 500 !important;
}

.BGMSubHeader-module__font-w-600___v3JUW {
  font-weight: 600 !important;
}

.BGMSubHeader-module__font-w-700___y0Of1 {
  font-weight: 700 !important;
}

.BGMSubHeader-module__p-5___Akv6w {
  padding: 5px !important;
}

.BGMSubHeader-module__p-12___YuTqw {
  padding: 12px !important;
}

.BGMSubHeader-module__p-16___AfsBB {
  padding: 16px !important;
}

.BGMSubHeader-module__p-30___sWvGM {
  padding: 30px !important;
}

.BGMSubHeader-module__p-b-0___ItGgA {
  padding-bottom: 0 !important;
}

.BGMSubHeader-module__p-b-5___hJMym {
  padding-bottom: 5px !important;
}

.BGMSubHeader-module__p-b-10___rdpgZ {
  padding-bottom: 10px !important;
}

.BGMSubHeader-module__p-b-12___DeSpT {
  padding-bottom: 12px !important;
}

.BGMSubHeader-module__p-b-16___qwx6l {
  padding-bottom: 16px !important;
}

.BGMSubHeader-module__p-b-18___Do_3a {
  padding-bottom: 18px !important;
}

.BGMSubHeader-module__p-b-20___UOhVA {
  padding-bottom: 20px !important;
}

.BGMSubHeader-module__p-b-25___rU_CO {
  padding-bottom: 25px !important;
}

.BGMSubHeader-module__p-b-30___IgRZL {
  padding-bottom: 30px !important;
}

.BGMSubHeader-module__p-b-50___F0qCN {
  padding-bottom: 50px !important;
}

.BGMSubHeader-module__p-t-0___OrfLa {
  padding-top: 0 !important;
}

.BGMSubHeader-module__p-t-12___v8bD0 {
  padding-top: 12px !important;
}

.BGMSubHeader-module__p-t-16___xoPdL {
  padding-top: 16px !important;
}

.BGMSubHeader-module__p-t-18___Jk9UV {
  padding-top: 18px !important;
}

.BGMSubHeader-module__p-t-20___t9jZR {
  padding-top: 20px !important;
}

.BGMSubHeader-module__p-t-30___hBQAU {
  padding-top: 30px !important;
}

.BGMSubHeader-module__p-t-40___Sgr1m {
  padding-top: 40px !important;
}

.BGMSubHeader-module__p-t-50___skWae {
  padding-top: 50px !important;
}

.BGMSubHeader-module__p-l-20___PStJw {
  padding-left: 20px !important;
}

.BGMSubHeader-module__p-l-30___fiSm0 {
  padding-left: 30px !important;
}

.BGMSubHeader-module__p-l-40___SE5Lb {
  padding-left: 40px !important;
}

.BGMSubHeader-module__p-r-16___dXKLd {
  padding-right: 16px !important;
}

.BGMSubHeader-module__p-r-20___jHZP_ {
  padding-right: 20px !important;
}

.BGMSubHeader-module__p-r-30___cJJCg {
  padding-right: 30px !important;
}

.BGMSubHeader-module__p-r-50___Yi6e7 {
  padding-right: 50px !important;
}

.BGMSubHeader-module__p-r-60___Mnu7R {
  padding-right: 60px !important;
}

.BGMSubHeader-module__m-b-1___AWykZ {
  margin-bottom: 1px !important;
}

.BGMSubHeader-module__m-b-2___mtbRn {
  margin-bottom: 2px !important;
}

.BGMSubHeader-module__m-b-6___VGcJT {
  margin-bottom: 6px !important;
}

.BGMSubHeader-module__m-b-8___KZecH {
  margin-bottom: 8px !important;
}

.BGMSubHeader-module__m-b-10___v778X {
  margin-bottom: 10px !important;
}

.BGMSubHeader-module__m-b-14___YmzRj {
  margin-bottom: 14px !important;
}

.BGMSubHeader-module__m-b-16___POWma {
  margin-bottom: 16px !important;
}

.BGMSubHeader-module__m-b-20___DodUr {
  margin-bottom: 20px !important;
}

.BGMSubHeader-module__m-b-22___qCOAE {
  margin-bottom: 22px !important;
}

.BGMSubHeader-module__m-b-24___QwaFB {
  margin-bottom: 24px !important;
}

.BGMSubHeader-module__m-b-30___HUDNz {
  margin-bottom: 30px !important;
}

.BGMSubHeader-module__m-b-32___DBj00 {
  margin-bottom: 32px !important;
}

.BGMSubHeader-module__m-b-40___Fpcgo {
  margin-bottom: 40px !important;
}

.BGMSubHeader-module__m-t-2___bE7b_ {
  margin-top: 2px !important;
}

.BGMSubHeader-module__m-t-3___TlMRf {
  margin-top: 3px !important;
}

.BGMSubHeader-module__m-t-4___iPqJd {
  margin-top: 4px !important;
}

.BGMSubHeader-module__m-t-5___eefEA {
  margin-top: 5px !important;
}

.BGMSubHeader-module__m-t-8___Rn0bC {
  margin-top: 8px !important;
}

.BGMSubHeader-module__m-t-10___vJTpq {
  margin-top: 10px !important;
}

.BGMSubHeader-module__m-t-15___YZ3ph {
  margin-top: 15px !important;
}

.BGMSubHeader-module__m-t-16___TgnF6 {
  margin-top: 16px !important;
}

.BGMSubHeader-module__m-t-20___VJgYc {
  margin-top: 20px !important;
}

.BGMSubHeader-module__m-t-22___QPktD {
  margin-top: 22px !important;
}

.BGMSubHeader-module__m-t-30___U7NnF {
  margin-top: 30px !important;
}

.BGMSubHeader-module__m-t-32___B4PKh {
  margin-top: 32px !important;
}

.BGMSubHeader-module__m-l-auto___eS7SU {
  margin-left: auto !important;
}

.BGMSubHeader-module__m-l-4___Ah7_t {
  margin-left: 4px !important;
}

.BGMSubHeader-module__m-l-5___fsgDO {
  margin-left: 5px !important;
}

.BGMSubHeader-module__m-l-6___X7vHX {
  margin-left: 6px !important;
}

.BGMSubHeader-module__m-l-8___ATJqm {
  margin-left: 8px !important;
}

.BGMSubHeader-module__m-l-10___wco5H {
  margin-left: 10px !important;
}

.BGMSubHeader-module__m-l-16___Zv9Vr {
  margin-left: 16px !important;
}

.BGMSubHeader-module__m-l-20____girR {
  margin-left: 20px !important;
}

.BGMSubHeader-module__m-l-24___nYkH9 {
  margin-left: 24px !important;
}

.BGMSubHeader-module__m-l-30____08zY {
  margin-left: 30px !important;
}

.BGMSubHeader-module__m-l-35___sSIFV {
  margin-left: 35px !important;
}

.BGMSubHeader-module__m-l-40___QZCV5 {
  margin-left: 40px !important;
}

.BGMSubHeader-module__m-r-8___jmezc {
  margin-right: 8px !important;
}

.BGMSubHeader-module__m-r-10___ZbIOo {
  margin-right: 10px !important;
}

.BGMSubHeader-module__m-r-16___NYYEl {
  margin-right: 16px !important;
}

.BGMSubHeader-module__m-r-20___eu3kS {
  margin-right: 20px !important;
}

.BGMSubHeader-module__m-r-24___t_AFp {
  margin-right: 24px !important;
}

.BGMSubHeader-module__m-r-30___K4xlv {
  margin-right: 30px !important;
}

.BGMSubHeader-module__m-r-40___tBi5s {
  margin-right: 40px !important;
}

.BGMSubHeader-module__border-r-3___BD_cs {
  border-radius: 3px !important;
}

.BGMSubHeader-module__border-r-4___nw1mK {
  border-radius: 4px !important;
}

.BGMSubHeader-module__border-r-6___CEtl2 {
  border-radius: 6px !important;
}

.BGMSubHeader-module__border-r-10___uXxmE {
  border-radius: 10px !important;
}

.BGMSubHeader-module__border-r-12___eTFc3 {
  border-radius: 12px !important;
}

.BGMSubHeader-module__border-r-16___aN22d {
  border-radius: 16px !important;
}

.BGMSubHeader-module__border-r-50___hd2cB {
  border-radius: 50% !important;
}

.BGMSubHeader-module__primary-border___LGo_x {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMSubHeader-module__primary-border-b___qRUNh {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMSubHeader-module__primary-border-t___Caq8L {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMSubHeader-module__primary-border-l___FgTna {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMSubHeader-module__primary-border-r___JJHTf {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMSubHeader-module__secondary-border___JQyNY {
  border: 1px solid #637768;
}

.BGMSubHeader-module__secondary-border-b___KGepR {
  border-bottom: 1px solid #637768;
}

.BGMSubHeader-module__secondary-border-t___lrpZ3 {
  border-top: 1px solid #637768;
}

.BGMSubHeader-module__secondary-border-l___pwTRn {
  border-left: 1px solid #637768;
}

.BGMSubHeader-module__secondary-border-r____JuD6 {
  border-right: 1px solid #637768;
}

.BGMSubHeader-module__gap-0___fGpw6 {
  gap: 0 !important;
}

.BGMSubHeader-module__gap-2___w0k9E {
  gap: 2px !important;
}

.BGMSubHeader-module__gap-4___n6kkY {
  gap: 4px !important;
}

.BGMSubHeader-module__gap-5___rsBgm {
  gap: 5px !important;
}

.BGMSubHeader-module__gap-6___qj6Wu {
  gap: 6px !important;
}

.BGMSubHeader-module__gap-8___mLDYA {
  gap: 8px !important;
}

.BGMSubHeader-module__gap-10___sSVpI {
  gap: 10px !important;
}

.BGMSubHeader-module__gap-12___k4rvR {
  gap: 12px !important;
}

.BGMSubHeader-module__gap-14___ZiLIp {
  gap: 14px !important;
}

.BGMSubHeader-module__gap-16___oL3jb {
  gap: 16px !important;
}

.BGMSubHeader-module__gap-18___I0QJL {
  gap: 18px !important;
}

.BGMSubHeader-module__gap-20___LpkyT {
  gap: 20px !important;
}

.BGMSubHeader-module__gap-24___ssssv {
  gap: 24px !important;
}

.BGMSubHeader-module__gap-26___U0O6I {
  gap: 26px !important;
}

.BGMSubHeader-module__gap-30___YHwGX {
  gap: 30px !important;
}

.BGMSubHeader-module__gap-32____RMrU {
  gap: 32px !important;
}

.BGMSubHeader-module__gap-40___Df2uQ {
  gap: 40px !important;
}

.BGMSubHeader-module__gap-50___iOSYH {
  gap: 50px !important;
}

.BGMSubHeader-module__flex-1___lxdxF {
  flex: 1;
}

.BGMSubHeader-module__flex-none___xVwOg {
  flex: none !important;
}

.BGMSubHeader-module__flex-column___UF47n {
  display: flex;
  flex-direction: column !important;
}

.BGMSubHeader-module__flex-row___l1Zzc {
  display: flex;
  flex-direction: row !important;
}

.BGMSubHeader-module__vertically-centered___ZlJgt {
  display: flex;
  align-items: center !important;
}

.BGMSubHeader-module__horizontally-centered___prTAp {
  display: flex;
  justify-content: center !important;
}

.BGMSubHeader-module__horizontally-end___zTli8 {
  display: flex;
  justify-content: end !important;
}

.BGMSubHeader-module__vertically-start___L9WkU {
  display: flex;
  align-items: start !important;
}

.BGMSubHeader-module__space-between___MuTAR {
  display: flex;
  justify-content: space-between !important;
}

.BGMSubHeader-module__flex-wrap___xxCyw {
  flex-wrap: wrap !important;
}

.BGMSubHeader-module__height-100___NSeLf {
  height: 100%;
}

.BGMSubHeader-module__width-50___Wkmw6 {
  width: 50% !important;
}

.BGMSubHeader-module__width-100___Nuada {
  width: 100%;
}

.BGMSubHeader-module__cursor-pointer___IYtiq {
  cursor: pointer;
}

.BGMSubHeader-module__cursor-not-allowed___Hti7E {
  cursor: not-allowed !important;
}

.BGMSubHeader-module__absolute-centered___NAr16 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMSubHeader-module__absolute___dHfpW {
  position: absolute;
}

.BGMSubHeader-module__relative___MvdFD {
  position: relative;
}

.BGMSubHeader-module__fixed___Hkebt {
  position: fixed;
}

.BGMSubHeader-module__visible___f6UDw {
  opacity: 1;
}

.BGMSubHeader-module__invisible___SMJDf {
  opacity: 0;
}

.BGMSubHeader-module__col-90___JiR_X {
  width: 90% !important;
}

.BGMSubHeader-module__col-auto___oN_VD {
  width: auto !important;
}

.BGMSubHeader-module__medical-tabs___k90te {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMSubHeader-module__medical-table-new___XsGwR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMSubHeader-module__medical-table-new___XsGwR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMSubHeader-module__medical-table-new___XsGwR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMSubHeader-module__medical-table-new___XsGwR::-webkit-scrollbar-track {
  display: none;
}
.BGMSubHeader-module__medical-table-new___XsGwR.BGMSubHeader-module__no-pagination___dg0au {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMSubHeader-module__medical-table-new___XsGwR.BGMSubHeader-module__no-pagination___dg0au:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMSubHeader-module__medical-table-new___XsGwR.BGMSubHeader-module__no-pagination___dg0au::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMSubHeader-module__medical-table-new___XsGwR.BGMSubHeader-module__no-pagination___dg0au::-webkit-scrollbar-track {
  display: none;
}

.BGMSubHeader-module__medical-table-empty___P5l9h {
  padding: 14px 40px !important;
}

.BGMSubHeader-module__icon-btn___HN9qd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMSubHeader-module__search-icon___dQARo {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMSubHeader-module__disable-select___EKARA {
  user-select: none;
}

.BGMSubHeader-module__break-word___xMlJD {
  word-break: break-word;
}

.BGMSubHeader-module__popup-clear-btn___A7Ack {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMSubHeader-module__scroll-m-b-20___jJWz5 {
  scroll-margin-bottom: 20px;
}

.BGMSubHeader-module__subHeader___FkPgM {
  color: #375844;
  width: calc(100% - 175px);
  margin-left: 96px;
  position: relative;
  border-width: 1.5px;
  margin-bottom: 26px;
}
.BGMSubHeader-module__subHeader___FkPgM::after {
  content: "";
  position: absolute;
  background-color: rgba(91, 91, 91, 0.2);
  height: 44px;
  left: -0.5px;
  width: 1px;
  top: 24.8px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/headers/BGMSubHeader/BGMSubHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.subHeader {\n  color: get-color(greenNew, dark);\n  width: calc(100% - 175px);\n  margin-left: 96px;\n  position: relative;\n  border-width: 1.5px;\n  margin-bottom: 26px;\n\n  &::after {\n    content: '';\n    position: absolute;\n    background-color: rgba(91, 91, 91, 0.2);\n    height: 44px;\n    left: -0.5px;\n    width: 1px;\n    top: 24.8px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMSubHeader-module__font-s-10___RlJ9_`,
	"fontS12": `BGMSubHeader-module__font-s-12___bd5bI`,
	"fontS13": `BGMSubHeader-module__font-s-13___IXCuW`,
	"fontS14": `BGMSubHeader-module__font-s-14___G8B4e`,
	"fontS15": `BGMSubHeader-module__font-s-15___lJlSW`,
	"fontS16": `BGMSubHeader-module__font-s-16___KkSJI`,
	"fontS18": `BGMSubHeader-module__font-s-18___A0dIY`,
	"fontS20": `BGMSubHeader-module__font-s-20___rkeuX`,
	"fontS22": `BGMSubHeader-module__font-s-22___YA1O6`,
	"fontS28": `BGMSubHeader-module__font-s-28___MHV_U`,
	"fontW400": `BGMSubHeader-module__font-w-400___WRTM4`,
	"fontW500": `BGMSubHeader-module__font-w-500___apj_r`,
	"fontW600": `BGMSubHeader-module__font-w-600___v3JUW`,
	"fontW700": `BGMSubHeader-module__font-w-700___y0Of1`,
	"p5": `BGMSubHeader-module__p-5___Akv6w`,
	"p12": `BGMSubHeader-module__p-12___YuTqw`,
	"p16": `BGMSubHeader-module__p-16___AfsBB`,
	"p30": `BGMSubHeader-module__p-30___sWvGM`,
	"pB0": `BGMSubHeader-module__p-b-0___ItGgA`,
	"pB5": `BGMSubHeader-module__p-b-5___hJMym`,
	"pB10": `BGMSubHeader-module__p-b-10___rdpgZ`,
	"pB12": `BGMSubHeader-module__p-b-12___DeSpT`,
	"pB16": `BGMSubHeader-module__p-b-16___qwx6l`,
	"pB18": `BGMSubHeader-module__p-b-18___Do_3a`,
	"pB20": `BGMSubHeader-module__p-b-20___UOhVA`,
	"pB25": `BGMSubHeader-module__p-b-25___rU_CO`,
	"pB30": `BGMSubHeader-module__p-b-30___IgRZL`,
	"pB50": `BGMSubHeader-module__p-b-50___F0qCN`,
	"pT0": `BGMSubHeader-module__p-t-0___OrfLa`,
	"pT12": `BGMSubHeader-module__p-t-12___v8bD0`,
	"pT16": `BGMSubHeader-module__p-t-16___xoPdL`,
	"pT18": `BGMSubHeader-module__p-t-18___Jk9UV`,
	"pT20": `BGMSubHeader-module__p-t-20___t9jZR`,
	"pT30": `BGMSubHeader-module__p-t-30___hBQAU`,
	"pT40": `BGMSubHeader-module__p-t-40___Sgr1m`,
	"pT50": `BGMSubHeader-module__p-t-50___skWae`,
	"pL20": `BGMSubHeader-module__p-l-20___PStJw`,
	"pL30": `BGMSubHeader-module__p-l-30___fiSm0`,
	"pL40": `BGMSubHeader-module__p-l-40___SE5Lb`,
	"pR16": `BGMSubHeader-module__p-r-16___dXKLd`,
	"pR20": `BGMSubHeader-module__p-r-20___jHZP_`,
	"pR30": `BGMSubHeader-module__p-r-30___cJJCg`,
	"pR50": `BGMSubHeader-module__p-r-50___Yi6e7`,
	"pR60": `BGMSubHeader-module__p-r-60___Mnu7R`,
	"mB1": `BGMSubHeader-module__m-b-1___AWykZ`,
	"mB2": `BGMSubHeader-module__m-b-2___mtbRn`,
	"mB6": `BGMSubHeader-module__m-b-6___VGcJT`,
	"mB8": `BGMSubHeader-module__m-b-8___KZecH`,
	"mB10": `BGMSubHeader-module__m-b-10___v778X`,
	"mB14": `BGMSubHeader-module__m-b-14___YmzRj`,
	"mB16": `BGMSubHeader-module__m-b-16___POWma`,
	"mB20": `BGMSubHeader-module__m-b-20___DodUr`,
	"mB22": `BGMSubHeader-module__m-b-22___qCOAE`,
	"mB24": `BGMSubHeader-module__m-b-24___QwaFB`,
	"mB30": `BGMSubHeader-module__m-b-30___HUDNz`,
	"mB32": `BGMSubHeader-module__m-b-32___DBj00`,
	"mB40": `BGMSubHeader-module__m-b-40___Fpcgo`,
	"mT2": `BGMSubHeader-module__m-t-2___bE7b_`,
	"mT3": `BGMSubHeader-module__m-t-3___TlMRf`,
	"mT4": `BGMSubHeader-module__m-t-4___iPqJd`,
	"mT5": `BGMSubHeader-module__m-t-5___eefEA`,
	"mT8": `BGMSubHeader-module__m-t-8___Rn0bC`,
	"mT10": `BGMSubHeader-module__m-t-10___vJTpq`,
	"mT15": `BGMSubHeader-module__m-t-15___YZ3ph`,
	"mT16": `BGMSubHeader-module__m-t-16___TgnF6`,
	"mT20": `BGMSubHeader-module__m-t-20___VJgYc`,
	"mT22": `BGMSubHeader-module__m-t-22___QPktD`,
	"mT30": `BGMSubHeader-module__m-t-30___U7NnF`,
	"mT32": `BGMSubHeader-module__m-t-32___B4PKh`,
	"mLAuto": `BGMSubHeader-module__m-l-auto___eS7SU`,
	"mL4": `BGMSubHeader-module__m-l-4___Ah7_t`,
	"mL5": `BGMSubHeader-module__m-l-5___fsgDO`,
	"mL6": `BGMSubHeader-module__m-l-6___X7vHX`,
	"mL8": `BGMSubHeader-module__m-l-8___ATJqm`,
	"mL10": `BGMSubHeader-module__m-l-10___wco5H`,
	"mL16": `BGMSubHeader-module__m-l-16___Zv9Vr`,
	"mL20": `BGMSubHeader-module__m-l-20____girR`,
	"mL24": `BGMSubHeader-module__m-l-24___nYkH9`,
	"mL30": `BGMSubHeader-module__m-l-30____08zY`,
	"mL35": `BGMSubHeader-module__m-l-35___sSIFV`,
	"mL40": `BGMSubHeader-module__m-l-40___QZCV5`,
	"mR8": `BGMSubHeader-module__m-r-8___jmezc`,
	"mR10": `BGMSubHeader-module__m-r-10___ZbIOo`,
	"mR16": `BGMSubHeader-module__m-r-16___NYYEl`,
	"mR20": `BGMSubHeader-module__m-r-20___eu3kS`,
	"mR24": `BGMSubHeader-module__m-r-24___t_AFp`,
	"mR30": `BGMSubHeader-module__m-r-30___K4xlv`,
	"mR40": `BGMSubHeader-module__m-r-40___tBi5s`,
	"borderR3": `BGMSubHeader-module__border-r-3___BD_cs`,
	"borderR4": `BGMSubHeader-module__border-r-4___nw1mK`,
	"borderR6": `BGMSubHeader-module__border-r-6___CEtl2`,
	"borderR10": `BGMSubHeader-module__border-r-10___uXxmE`,
	"borderR12": `BGMSubHeader-module__border-r-12___eTFc3`,
	"borderR16": `BGMSubHeader-module__border-r-16___aN22d`,
	"borderR50": `BGMSubHeader-module__border-r-50___hd2cB`,
	"primaryBorder": `BGMSubHeader-module__primary-border___LGo_x`,
	"primaryBorderB": `BGMSubHeader-module__primary-border-b___qRUNh`,
	"primaryBorderT": `BGMSubHeader-module__primary-border-t___Caq8L`,
	"primaryBorderL": `BGMSubHeader-module__primary-border-l___FgTna`,
	"primaryBorderR": `BGMSubHeader-module__primary-border-r___JJHTf`,
	"secondaryBorder": `BGMSubHeader-module__secondary-border___JQyNY`,
	"secondaryBorderB": `BGMSubHeader-module__secondary-border-b___KGepR`,
	"secondaryBorderT": `BGMSubHeader-module__secondary-border-t___lrpZ3`,
	"secondaryBorderL": `BGMSubHeader-module__secondary-border-l___pwTRn`,
	"secondaryBorderR": `BGMSubHeader-module__secondary-border-r____JuD6`,
	"gap0": `BGMSubHeader-module__gap-0___fGpw6`,
	"gap2": `BGMSubHeader-module__gap-2___w0k9E`,
	"gap4": `BGMSubHeader-module__gap-4___n6kkY`,
	"gap5": `BGMSubHeader-module__gap-5___rsBgm`,
	"gap6": `BGMSubHeader-module__gap-6___qj6Wu`,
	"gap8": `BGMSubHeader-module__gap-8___mLDYA`,
	"gap10": `BGMSubHeader-module__gap-10___sSVpI`,
	"gap12": `BGMSubHeader-module__gap-12___k4rvR`,
	"gap14": `BGMSubHeader-module__gap-14___ZiLIp`,
	"gap16": `BGMSubHeader-module__gap-16___oL3jb`,
	"gap18": `BGMSubHeader-module__gap-18___I0QJL`,
	"gap20": `BGMSubHeader-module__gap-20___LpkyT`,
	"gap24": `BGMSubHeader-module__gap-24___ssssv`,
	"gap26": `BGMSubHeader-module__gap-26___U0O6I`,
	"gap30": `BGMSubHeader-module__gap-30___YHwGX`,
	"gap32": `BGMSubHeader-module__gap-32____RMrU`,
	"gap40": `BGMSubHeader-module__gap-40___Df2uQ`,
	"gap50": `BGMSubHeader-module__gap-50___iOSYH`,
	"flex1": `BGMSubHeader-module__flex-1___lxdxF`,
	"flexNone": `BGMSubHeader-module__flex-none___xVwOg`,
	"flexColumn": `BGMSubHeader-module__flex-column___UF47n`,
	"flexRow": `BGMSubHeader-module__flex-row___l1Zzc`,
	"verticallyCentered": `BGMSubHeader-module__vertically-centered___ZlJgt`,
	"horizontallyCentered": `BGMSubHeader-module__horizontally-centered___prTAp`,
	"horizontallyEnd": `BGMSubHeader-module__horizontally-end___zTli8`,
	"verticallyStart": `BGMSubHeader-module__vertically-start___L9WkU`,
	"spaceBetween": `BGMSubHeader-module__space-between___MuTAR`,
	"flexWrap": `BGMSubHeader-module__flex-wrap___xxCyw`,
	"height100": `BGMSubHeader-module__height-100___NSeLf`,
	"width50": `BGMSubHeader-module__width-50___Wkmw6`,
	"width100": `BGMSubHeader-module__width-100___Nuada`,
	"cursorPointer": `BGMSubHeader-module__cursor-pointer___IYtiq`,
	"cursorNotAllowed": `BGMSubHeader-module__cursor-not-allowed___Hti7E`,
	"absoluteCentered": `BGMSubHeader-module__absolute-centered___NAr16`,
	"absolute": `BGMSubHeader-module__absolute___dHfpW`,
	"relative": `BGMSubHeader-module__relative___MvdFD`,
	"fixed": `BGMSubHeader-module__fixed___Hkebt`,
	"visible": `BGMSubHeader-module__visible___f6UDw`,
	"invisible": `BGMSubHeader-module__invisible___SMJDf`,
	"col90": `BGMSubHeader-module__col-90___JiR_X`,
	"colAuto": `BGMSubHeader-module__col-auto___oN_VD`,
	"medicalTabs": `BGMSubHeader-module__medical-tabs___k90te`,
	"medicalTableNew": `BGMSubHeader-module__medical-table-new___XsGwR`,
	"noPagination": `BGMSubHeader-module__no-pagination___dg0au`,
	"medicalTableEmpty": `BGMSubHeader-module__medical-table-empty___P5l9h`,
	"iconBtn": `BGMSubHeader-module__icon-btn___HN9qd`,
	"searchIcon": `BGMSubHeader-module__search-icon___dQARo`,
	"disableSelect": `BGMSubHeader-module__disable-select___EKARA`,
	"breakWord": `BGMSubHeader-module__break-word___xMlJD`,
	"popupClearBtn": `BGMSubHeader-module__popup-clear-btn___A7Ack`,
	"scrollMB20": `BGMSubHeader-module__scroll-m-b-20___jJWz5`,
	"subHeader": `BGMSubHeader-module__subHeader___FkPgM`
};
module.exports = ___CSS_LOADER_EXPORT___;
